
class Threshold {
  constructor(rdg, label, min, max, term, good, bad, crit, bad2, crit2){
    this.rdg = rdg;
    this.label = label;
    this.min = min;
    this.max = max;
    this.term = term;
    this.good = good;
    this.bad = bad;
    this.crit = crit;
    if (bad2) this.bad2 = bad2;
    if (crit2) this.crit2 = crit2;
  }
}

export default {
  days: new Threshold('days', 'Days Remaining', 0, 200, 'days', {min: 20, max: 1000}, {min: 7, max: 19}, {min: 0, max: 6}),
  ttp: new Threshold('ttp', 'Temperature', -20, 50, '˚', {min: 19, max: 24}, {min: 25, max: 32}, {min: 33, max: 50}, {min: 10, max: 18}, {min: -40, max: 9}),
  hhm: new Threshold('hhm', 'Humidity', 0, 100, '%', {min: 30, max: 50}, {min: 51, max: 75}, {min: 76, max: 100}, {min: 16, max: 29}, {min: 0, max: 15}),
  iaq: new Threshold('iaq', 'Air Quality', 0, 1000, '', {min: 0, max: 100}, {min: 101, max: 250}, {min: 251, max: 1000}),
  co2: new Threshold('co2', 'CO2', 0, 10000, 'ppm', {min: 0, max: 1500}, {min: 1501, max: 2500}, {min: 2501, max: 10000}),
  voc: new Threshold('voc', 'tVOC', 0, .734, 'ppm', {min: 0, max: .122}, {min: .123, max: .244}, {min: .245, max: .734}),
  deltaPressure95Percentile: new Threshold('deltaPressure95Percentile', 'Coil Pressure', 0, 500, 'Pa', {min: 0, max: 496}, {min: 497, max: 498}, {min: 499, max: 500})
}



// WEBPACK FOOTER //
// ./src/lib/genThresh.js